import axios from 'axios'
import authHeader from './AuthHeader'
import { API_URL } from '../config/api'

class PayrollsService {

    // Get payrolls list
    getPayrolls = async (pageNum, search = '', limit = false, sortBy = 'name', sortOrder = 'asc', userId = '') => {
        return await axios.get(API_URL + '/payrolls?page=' + pageNum + '&search=' + search + '&limit=' + limit + '&sortBy=' + sortBy + '&sortOrder=' + sortOrder + '&userId=' + userId, { headers: authHeader() })
    }

    // Add new payroll
    addPayroll = async (payroll) => {
        return await axios.post(API_URL + '/payrolls', payroll, { headers: authHeader() })
    }

    // Update payroll data
    updatePayroll = async (payroll, id) => {
        return await axios.patch(API_URL + '/payrolls/' + id, payroll, { headers: authHeader() })
    }

    // Get payroll data
    getPayroll = async (id) => {
        return await axios.get(API_URL + '/payrolls/' + id, { headers: authHeader() })
    }

    // Delete payroll
    deletePayroll = async (id) => {
        return await axios.delete(API_URL + '/payrolls/' + id, { headers: authHeader() })
    }

    // Get payrolls chart dataset
    getPayrollsDataset = async ({ userId = '', yearFrom = '', yearTo = '' }) => {
        // Crear una base de la URL
        let url = API_URL + '/dataset/payrolls?'

        // Añadir parámetros opcionales si existen
        if (userId) {
            url += `userId=${userId}&`
        }
        if (yearFrom) {
            url += `yearFrom=${yearFrom}&`
        }
        if (yearTo) {
            url += `yearTo=${yearTo}&`
        }

        // Eliminar el último '&' si lo hay
        url = url.endsWith('&') ? url.slice(0, -1) : url
        return await axios.get(url, { headers: authHeader() })
    }
}

export default new PayrollsService()